import styled from "styled-components"
import { device } from "breakpoints"
import AvenueImg from "../../UI/AvenueImg"

export const CaseStudyContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e9eef2;
  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  margin-bottom: 24px;

  @media ${device.desktop} {
    margin-bottom: 53px;
  }

  /*
   TODO: Will have to remove this AvenueImg and set a proper image from the CaseStudyLogo below 
   */
  .avenueImg {
    margin: 0;

    > div {
      padding-bottom: 30% !important;
      @media ${device.desktop} {
        padding-bottom: 35% !important;
      }
    }
  }
`
export const CaseStudyTitle = styled.h5`
  background-image: linear-gradient(-27deg, #67dbc3 0%, #2e648a 81%);
  border-radius: 10px 10px 0 0;

  font-size: Bold;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 20px;
  padding: 15px 20px;
`
// export const CaseStudyLogo = styled(AvenueImg)`
//   position: relative;
//   width: 100%;
//   flex-shrink: 0;
//   overflow: hidden;
//   background: ${(props) => props.theme.navy};
//   margin-bottom: 10px;

//   &.avenueImg__imgWrapper {
//     padding-bottom: ${(props) =>
//       props.imgAspectRatio && `${(1 / props.imgAspectRatio) * 100}%`};

//     img {
//       position: absolute;
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 100%;
//     }
//   }
// `
export const CaseStudyCategoryContainer = styled.div`
  border-top: 1px solid #e2e8ed;
  padding: 20px 21px 10px;

  @media ${device.large} {
    padding: 14px 21px 10px;
  }
`
export const CaseStudyCategory = styled.p`
  font-weight: 500;
  font-size: 10px;
  color: #9ba3a8;
  letter-spacing: 0;
  line-height: 17px;

  @media ${device.large} {
    font-size: 12px;
    line-height: 21px;
  }
`
export const CaseStudyCategoryName = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: #303b45;
  letter-spacing: 0;
  line-height: 24px;

  @media ${device.large} {
    font-size: 16px;
    line-height: 23px;
  }
`
export const CaseStudyAwardContainer = styled.div`
  border-top: 1px solid #e2e8ed;
  margin: 0 20px 20px;
  padding-top: 19px;

  @media ${device.large} {
    margin: 2px 20px 20px;
    padding-top: 14px;
  }
`

export const CSImage = styled.div`
  padding: 15px;

  @media ${device.desktop} {
    padding: 21px;
  }

  .gatsby-image-wrapper > div {
    padding: 0 !important;
  }

  img {
    position: static !important;
  }
`

export const CaseStudyAward = styled(CaseStudyCategory)``
export const CaseStudyAwardName = styled(CaseStudyCategoryName)``
